import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@material-ui/core';
import MinicaseForm from './MinicaseForm';
import {API} from 'aws-amplify';
import {toast} from 'react-toastify';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import loans from '../../config/loans';
import { useBreadcrumbActions } from '../../providers/breadcrumbProvider';

const EditMinicase = ({onReload}) => {
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [initialMinicase, setInitialMinicase] = useState();
  const [error, setError] = useState();
  const breadcrumbActions = useBreadcrumbActions();

  let { id } = useParams();

  useEffect(() => {
    let aborted = false;
    const load = async () => {
      try {
        const result = await API.get('mongo', `/cases/${id}`);
        result.loanTypes = loans;
        if (!aborted) {
          setInitialMinicase(result);
        }
      } catch(e) {
        if (e.response && e.response.status === 404) {
          setError("Emerging situation not found");
        } else {
          throw e;
        }
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    load();
    return () => aborted = true;
  }, [id]);

  const onSubmit = async (form) => {
    setSaving(true);
    try {
      await API.put('mongo', `/cases/${id}`, {body: form});
      toast.success('Emerging Situation saved');
      if (onReload) {
        onReload();
      }
      breadcrumbActions.pop();
    } catch (e) {
      toast.error(e.toString());
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box>
      <Typography variant="h4">
        Edit Minicase
      </Typography>
      { // TODO: error screen
        error
      }
      { // TODO: loading screen
        !loading && !error &&
        <MinicaseForm
          onSubmit={onSubmit}
          initialValue={initialMinicase}
          disabled={saving}
        />
      }

    </Box>
  );
};

EditMinicase.propTypes = {
  history: PropTypes.object.isRequired,
  onReload: PropTypes.string.isRequired
};

export default EditMinicase;
